import {useIntl} from 'react-intl'
import RemoveDiscountBulkCard from './add-special/RemoveDiscountBulkCard'
import './add-special/add-discount-bulk.css'

// Reuses the bulk-update / Add Discount - Bulk visual system (.adb-*); only the
// card body (RemoveDiscountBulkCard) keeps its own remove-discount API
// implementation (remove-by-bulk-special).
const RemoveSpecialBulk = () => {
  const {formatMessage} = useIntl()

  return (
    <div className='adb-root'>
      <div className='adb-header'>
        <div>
          <h1 className='adb-title'>{formatMessage({id: 'delete_discount_bulk'})}</h1>
          {/* Multi-supplier (B6): only the supplier's OWN offer discount is
              removed — a competitor's discount on the same product is untouched.
              Per-row result is in the downloaded file. */}
          <div className='adb-note' role='note'>
            <i className='fas fa-circle-info' aria-hidden='true' />
            <span>{formatMessage({id: 'bulk_remove_special_offer_note'})}</span>
          </div>
        </div>
      </div>

      <RemoveDiscountBulkCard />
    </div>
  )
}

export default RemoveSpecialBulk
